import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const NotificationsActions = {
  getNotifications: async ({ commit }, params) => {
    return axiosRequest.
      get('/users/notifications', { params }).
      then(({ data }) => {
        commit('setNotificationsList', data.results)
        commit('setTotalNotificationsCount', data.total_notifications_count)
        commit('setUnreadNotificationsCount', data.unread_notifications_count)

        return data
      }).
      catch(handleError)
  },

  updateLatestUnreadNotifications: async ({ commit }) => {
    return axiosRequest.
      get(
        '/users/notifications',
        {
          params: {
            page: 1,
            results_per_page: 20,
            sort_by: 'created_at',
            sort_order: 'desc',
            filters: {
              status: 'new',
            },
          },
        }
      ).
      then(({ data }) => {
        commit('setRecentUnreadNotifications', data.results)
        commit('setTotalNotificationsCount', data.total_notifications_count)
        commit('setUnreadNotificationsCount', data.unread_notifications_count)
      }).
      catch(handleError)
  },

  addNotification: async ({ commit, state }, notification) => {
    commit('setRecentUnreadNotifications', [notification, ...state.recentUnreadNotifications])
    commit('setTotalNotificationsCount', state.totalNotificationsCount + 1)
    commit('setUnreadNotificationsCount', state.unreadNotificationsCount + 1)
  },

  setNotificationAsRead: async ({ commit }, notificationId) => {
    return axiosRequest.
      patch(`/users/notifications/${notificationId}/mark_read`).
      then(({ data }) => {
        commit('setNotificationAsRead', notificationId)
        commit('setTotalNotificationsCount', data.total_notifications_count)
        commit('setUnreadNotificationsCount', data.unread_notifications_count)
      }).
      catch(handleError)
  },

  setAllNotificationsAsRead: async ({ commit }) => {
    return axiosRequest.
      patch('/users/notifications/mark_all_read').
      then(({ data }) => {
        commit('setAllNotificationsAsRead')
        commit('setTotalNotificationsCount', data.total_notifications_count)
        commit('setUnreadNotificationsCount', data.unread_notifications_count)
      }).
      catch(handleError)
  },
}
